import { render } from "./queryOverrides.vue?vue&type=template&id=990a8fc8"
import script from "./queryOverrides.vue?vue&type=script&lang=js"
export * from "./queryOverrides.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__